import type { ProductDetailsData } from "@jti/fe-common";

import type { BundleConfig } from "@/components/BundleProduct/utils/getBundleConfig";
import type { ConfigurableOptions } from "@/components/ConfigurableProduct/utils/getConfigurableOptions";
import type { ProductSpecificationProps } from "@/components/ProductSpecification/ProductSpecification.inputs.builder";
import type { ProductTeaserCarouselProps } from "@/components/ProductTeaserCarousel/ProductTeaserCarousel.inputs";
import type { StandardProductDetailsContainerProps } from "@/components/StandardProductDetailsContainer/StandardProductDetailsContainer.inputs.builder";

import { createSafeContentWithData } from "../builder/tools/createSafeContentWithData/createSafeContentWithData";

import type { ProductsMap } from "./products";

const { Content: ProductContent, createDefaultDataBindings: createProductDefaultDataBinding } =
  createSafeContentWithData<{
    productName: string;
    productPrice: string;
    productImageSrc: string;
    productCustomAttributes: ProductSpecificationProps["customAttributes"];
    productSku: string;
    productOverwriteBadgeText: string;
    productDescription: string;
    productCurrentVariantId: string;
    productIsBundle: boolean;
    productMultiPackProducts: ProductDetailsData["multiPackProducts"];
    productBundlesConfig: BundleConfig;
    productCategories: StandardProductDetailsContainerProps["categories"];
    productHideCta: boolean;
    productHidePrice: boolean;
    productIsTrial: boolean;
    productConfigurableOptions: ConfigurableOptions;
    productDynamicGallery: unknown[] | null;
    productVideoGallery: string[];
    productTrustpilot: { isEnabled: boolean };
    productMultiPackName: string;
    productMultiPackDescription: string;
    productGalleryAssets: StandardProductDetailsContainerProps["galleryAssets"];
    productHasDiscountBadge: boolean;
    productIsMultiPackEnabled: boolean;
    productHasStrikethroughPrice: boolean;
    productIsCommerceDisabled: boolean;
    productKnowMoreUrl: string;
    productIsDynamicGalleryEnabled: boolean;
    productCurrentVariantSku: string;
    productNonTradeInSku: string;
    productIsTradeIn: boolean;
    productHasRegistrationConsent: boolean;
    productMandatoryPositiveConsent: boolean;
    teaserProducts: ProductTeaserCarouselProps["items"];
    products: ProductsMap;
  }>();

export { createProductDefaultDataBinding, ProductContent };
